export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Miercoles_eng_scroll.3cffb267.png";